import React from 'react';
import LockIcon from '@mui/icons-material/Lock';

import { DocumentAccessLevel } from 'utils/api/modules/entities/entities.types';

import { PermissionBadgeStyled } from './styles';

interface PermissionBadgeProps {
  accessLevel: DocumentAccessLevel | null;
  isOwner: boolean;
  onClick?: () => void;
}

const PermissionBadge: React.FC<PermissionBadgeProps> = ({ accessLevel, isOwner, onClick }) => {
  if (isOwner) {
    return (
      <PermissionBadgeStyled $level="owner" $clickable={Boolean(onClick)} onClick={onClick}>
        Owner
      </PermissionBadgeStyled>
    );
  }

  if (accessLevel === DocumentAccessLevel.Edit) {
    return (
      <PermissionBadgeStyled $level="edit" $clickable={Boolean(onClick)} onClick={onClick}>
        Can edit
      </PermissionBadgeStyled>
    );
  }

  if (accessLevel === DocumentAccessLevel.View) {
    return (
      <PermissionBadgeStyled $level="view" $clickable={Boolean(onClick)} onClick={onClick}>
        <LockIcon sx={{ fontSize: 14 }} />
        View only
      </PermissionBadgeStyled>
    );
  }

  return null;
};

export default PermissionBadge;
